import { getFirebaseBackend } from '../../helpers/firebaseHelper';

const fetchTeamTable = async (accountId) => {
  const firebaseHelper = getFirebaseBackend();
  const team = (await firebaseHelper.getTeam(accountId)) || {};

  const processedTeam = await Promise.all(
    Object.values(team)
      .filter((user) => user.id !== 'initialTeamState')
      .map(async (user) => {
        const userData = await firebaseHelper.getUser(user.id);
        return {
          id: user.id,
          name: `${user.name} ${user.lastName}`,
          email: userData.email,
          adminStatus: userData.adminStatus,
        };
      }),
  );

  return processedTeam;
};

export { fetchTeamTable };
